import { render, staticRenderFns } from "./uusi-koulutusjakso.vue?vue&type=template&id=f167c024&scoped=true&"
import script from "./uusi-koulutusjakso.vue?vue&type=script&lang=ts&"
export * from "./uusi-koulutusjakso.vue?vue&type=script&lang=ts&"
import style0 from "./uusi-koulutusjakso.vue?vue&type=style&index=0&id=f167c024&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f167c024",
  null
  
)

export default component.exports